import React from "react";
import { useState, useCallback, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import navValues from "../components/Menu/NavValues";
import MenuPicker from "../components/Menu/MenuPicker";
import Paintings from "./Paintings";
import {
  SetTokenStatus,
  GetTokenFromLocalStorage,
} from "../components/Account/AuthenticationContext";
import { loadStores } from "../components/StoreBuilder";

//if page is refreshed we need to check the token status
//and set the initial value of the menu
SetTokenStatus();
var currentState: string =
  GetTokenFromLocalStorage() !== null
    ? navValues.loggedIn
    : navValues.loggedOut;

const navigationContext = React.createContext(currentState) as any;

const Root = (): any => {
  const navigate = useCallback(
    (useNav: any) => setNav({ current: useNav, navigate }),
    []
  );
  const [nav, setNav] = useState({ current: currentState, navigate }) as any;

  const location = useLocation();

  useEffect(() => {
    //load stores that require calls to the server
    let stores: any = { data: [] };
    let shipping: any = {
      storeName: "Shipping",
      uri: "Painting/GetAllShipping",
    };
    let enabledShipping: any = {
      storeName: "EnabledShipping",
      uri: "Painting/GetEnabledShipping",
    };
    let sizes: any = { storeName: "Sizes", uri: "Painting/GetAllSizes" };
    stores.data.push(shipping);
    stores.data.push(enabledShipping);
    stores.data.push(sizes);
    loadStores(stores);
  }, []);

  return (
    <>
      <navigationContext.Provider value={nav}>
        <MenuPicker currentNav={nav.current} />
      </navigationContext.Provider>
      {location.pathname === "/" && (
        <Paintings
          Title="Paintings"
          MaxRows={6}
          Params={{ mcode: location.search }}
        />
      )}
    </>
  );
};

export { navigationContext };
export default Root;
